import { Auditable, Case, QueryParams, SortParams } from "..";

export interface CaseNote extends Auditable {
    caseId: number | string;
    note: string;
    case?: Case;
}

export const DefaultCaseNoteQueryParams: QueryParams = {
    createdById: "",
};

export const DefaultCaseNoteSortParams: SortParams = {
    orderBy: "createdOn",
    orderDesc: "true",
};
